<template>
  <svg
    class="absolute top-0 left-1/2 transform -translate-x-1/2 -mt-2.5 w-5 h-auto transition-opacity"
    xmlns="http://www.w3.org/2000/svg"
    width="47.832"
    height="47.832"
    viewBox="0 0 47.832 47.832"
  >
    <circle
      id="Ellipse_165"
      data-name="Ellipse 165"
      cx="23.916"
      cy="23.916"
      r="23.916"
      fill="#fe3c38"
    ></circle>
    <path
      id="Path_1024"
      data-name="Path 1024"
      d="M1691.839,1533.375l5.9,5.9,14.016-14.016"
      transform="translate(-1677.879 -1508.349)"
      fill="none"
      stroke="#fff"
      stroke-width="2"
    ></path>
  </svg>
</template>
